// Reads a boolean REACT_APP_* flag. Never throws: these are evaluated at module
// scope, so a bad value used to reject the chunk's dynamic import and blank the
// whole page. Docker turns an unset build-arg into an empty ENV value
// (`ENV X=$X`), so "" has to mean "not set" rather than JSON.parse("").
export function parseEnvBool(rawValue, defaultValue) {
  const value = typeof rawValue === "string" ? rawValue.trim() : rawValue
  if (value === undefined || value === null || value === "") return defaultValue
  if (value === "true") return true
  if (value === "false") return false
  // eslint-disable-next-line no-console
  console.warn(`Ignoring unparseable boolean env flag, expected "true" or "false": ${JSON.stringify(rawValue)}`)
  return defaultValue
}

const BUSINESS_CALL_NOT_SUPPORT_COUNTRIES = ["1", "20", "84", "234"]

export function isBusinessCallSupported(phoneNumber) {
  if (!phoneNumber) return false
  return !BUSINESS_CALL_NOT_SUPPORT_COUNTRIES.find((prefix) => phoneNumber.startsWith(prefix))
}
